export default "/_nuxt/31ef17c8b8756e71e185360be3254166.svg";